/**
 * The kind of a needs-a-person item, as the pill the gaps table and the
 * workflow's Needs review list lead with. One component so "Blocks" is the
 * same red everywhere it appears.
 */

import React from "react";

import StatusPill from "../StatusPill";
import { REVIEW_KIND_LABEL, type ReviewKind } from "./dealScreeningReview";

const TONE: Record<ReviewKind, "red" | "amber" | "grey"> = {
	blocks: "red",
	required: "red",
	conflict: "amber",
	stale: "amber",
	gap: "amber",
	omitted: "grey",
};

interface ReviewKindPillProps {
	kind: ReviewKind;
}

const ReviewKindPill: React.FC<ReviewKindPillProps> = ({ kind }) => (
	<StatusPill tone={TONE[kind]} label={REVIEW_KIND_LABEL[kind]} />
);

export default React.memo(ReviewKindPill);
